import { Injectable } from "@angular/core";
import { Archive } from "@interface/Archive";
import { Period } from "@interface/Period";
import moment from "moment"
@Injectable()
export class KeepService {
    private __archive: Array<Archive> = [];
    private __period: Period = {
        from: new Date(moment().utc().subtract(3, 'month').toISOString()),
        to: new Date(moment().utc().add(1, 'day').toISOString()),
    }
    private __isset: boolean = true;
    constructor() {

    }
    public init(_archive: Array<Archive>): void {
        this.__archive = [..._archive];
        this.__isset = true;
    }
    public set period(_v: Period) {
        
        this.__period = { ..._v };

    }
    public get archive(): Array<Archive> {
        return this.__archive;
    }
    public get isset(): boolean {
        return this.__isset;
    }
    public get period(): Period {
        return this.__period;
    }

}


// WEBPACK FOOTER //
// ./src/providers/keep.service.ts